<div class="navbar-container d-flex content">

  <div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <a class="navbar-brand" [routerLink]="['/' + subdomain + '/']">
          <span class="brand-logo">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
          </span>
          <h2 class="brand-text mb-0">{{ companyHeaderTitle }}</h2>
        </a>
      </li>
    </ul>
    <!--/ Navbar brand -->
  </div>

  <div class="bookmark-wrapper d-flex align-items-center d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
  </div>

  <app-navbar-search class="benefits-search"></app-navbar-search>

  <ul class="nav navbar-nav align-items-center">
    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
        role="button"
      >
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">{{username}}</span><span class="user-status">{{email}}</span>
        </div>
        <span class="avatar" style="background-image: url('{{profilePictureSrc}}'); width: 40px; height: 40px;background-position: center;background-size: cover;"
          >
          <!-- <img
            class="round"
            src=
            alt="avatar"
            height="40"
            width="40" /> -->
            <span class="avatar-status-online"></span
        ></span>
      </a>
      <div ngbDropdownMenu
           aria-labelledby="navbarUserDropdown"
           class="dropdown-menu dropdown-menu-right" role="menu">
        <a ngbDropdownItem role="menuitem" [routerLink]="['/' + subdomain + '/profile']"><span [data-feather]="'user'" [class]="'mr-50'"></span> {{ 'PROFILE_MENU.PROFILE' | translate}}</a>
        <a ngbDropdownItem role="menuitem" href="{{selfServiceLink}}" *ngIf="selfServiceEnabled"><span [data-feather]="'pie-chart'" [class]="'mr-50'"></span> {{ 'PROFILE_MENU.ADMIN' | translate}}</a>
        <a ngbDropdownItem role="menuitem" href="{{faqLink}}" target="_blank" *ngIf="faqLinkIsSet"><span [data-feather]="'book-open'" [class]="'mr-50'"></span> {{ 'PROFILE_MENU.FAQ' | translate}}</a>

        <div class="dropdown-divider"></div>
        <div ngbDropdownItem role="menuitem" (click)="logout()">
          <span [data-feather]="'power'" [class]="'mr-50'"></span>
          {{ 'PROFILE_MENU.LOGOUT' | translate }}
        </div>
      </div>
    </li>

    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        ngbDropdownToggle
        id="navbarLanguageDropdown"
        aria-haspopup="true"
        role="button"
        aria-expanded="false"
        aria-controls="languageMenu"
      >
        {{ selectedLanguage }}
      </a>
      <div
        id="languageMenu"
        ngbDropdownMenu
        aria-labelledby="navbarLanguageDropdown"
        class="dropdown-menu dropdown-menu-right"
        role="menu"
      >
        <div ngbDropdownItem (click)="setLanguage('ro')" role="menuitem">ro</div>
        <div ngbDropdownItem (click)="setLanguage('en')"  role="menuitem">en</div>
      </div>
    </li>
  </ul>
</div>

